import { render, staticRenderFns } from "./comp_UserOrderDetail-PaymentInstructions-Modo.vue?vue&type=template&id=4f434d0f&"
import script from "./comp_UserOrderDetail-PaymentInstructions-Modo.vue?vue&type=script&lang=js&"
export * from "./comp_UserOrderDetail-PaymentInstructions-Modo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports